import { render } from "./CIS-Wistia-Video.vue?vue&type=template&id=09ec5085"
import script from "./CIS-Wistia-Video.vue?vue&type=script&lang=js"
export * from "./CIS-Wistia-Video.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__